import { styled, Box, ThemeType } from '@project-minerva/design-system'

export const HeaderWidgetTooltip = styled(Box)(({ theme }: { theme: ThemeType }) => ({
  padding: theme.spacing(3),
  position: 'relative',
}))
